const LOGOUT_BROADCAST_KEY = "app:logout-broadcast"
const LOGIN_BROADCAST_KEY = "app:login-broadcast"

export const broadcastLogout = () => {
  localStorage.setItem(LOGOUT_BROADCAST_KEY, Date.now().toString())
  localStorage.removeItem(LOGOUT_BROADCAST_KEY)
}

export const initCrossTabLogoutListener = (onLogout: () => void): (() => void) => {
  const handler = (event: StorageEvent) => {
    if (event.key === LOGOUT_BROADCAST_KEY) {
      onLogout()
    }
  }
  window.addEventListener("storage", handler)
  return () => window.removeEventListener("storage", handler)
}

export const broadcastLogin = (email: string) => {
  localStorage.setItem(LOGIN_BROADCAST_KEY, JSON.stringify({ email, timestamp: Date.now() }))
  localStorage.removeItem(LOGIN_BROADCAST_KEY)
}

export const initCrossTabLoginListener = (
  getCurrentEmail: () => string | null,
  onDifferentUserLogin: () => void
): (() => void) => {
  const handler = (event: StorageEvent) => {
    if (event.key === LOGIN_BROADCAST_KEY && event.newValue) {
      try {
        const data = JSON.parse(event.newValue) as { email: string }
        const currentEmail = getCurrentEmail()
        if (currentEmail && data.email !== currentEmail) {
          onDifferentUserLogin()
        }
      } catch {
        // ignore malformed events
      }
    }
  }
  window.addEventListener("storage", handler)
  return () => window.removeEventListener("storage", handler)
}
